import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

// Collapsible Community home section — HUD glass header with chevron, smooth
// spring collapse/expand, expanded by default, choice persisted per section.
export function CollapsibleSection({ title, subtitle, icon: Icon, persistKey, headerRight, children, testid }) {
  const [open, setOpen] = useState(() => {
    try { const v = localStorage.getItem(persistKey); return v === null ? true : v !== 'false'; } catch { return true; }
  });
  const toggle = () => setOpen((o) => {
    const n = !o;
    try { localStorage.setItem(persistKey, String(n)); } catch { /* ignore */ }
    return n;
  });

  return (
    <section data-testid={testid}>
      <div className="flex items-center gap-3">
        <button onClick={toggle} className="hg-press flex items-center gap-3 flex-1 min-w-0 text-left" data-testid={`${testid}-toggle`}>
          {Icon && <span className="w-9 h-9 rounded-full bg-[#6B9F4A]/14 flex items-center justify-center flex-shrink-0"><Icon className="w-4 h-4 text-[#1A4331]" /></span>}
          <span className="flex-1 min-w-0">
            <h3 className="text-2xl font-bold text-[#1A4331] leading-tight truncate" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</h3>
            {subtitle && <span className="block text-xs text-[#7A6B57] truncate">{subtitle}</span>}
          </span>
          <motion.span animate={{ rotate: open ? 0 : -90 }} transition={{ type: 'spring', stiffness: 320, damping: 26 }} className="text-[#1A4331] flex-shrink-0">
            <ChevronDown className="w-6 h-6" />
          </motion.span>
        </button>
        {headerRight}
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 220, damping: 30, opacity: { duration: 0.2 } }}
            style={{ overflow: 'hidden' }}
          >
            <div className="pt-4">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
